import { ArrowUpRight } from "lucide-react";
import { MarkCircleSeal } from "./MedpaxLogo";

export const Hero = () => {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-12 gap-8 lg:gap-16 items-end">
                <div className="col-span-12 lg:col-span-7 min-w-0">
                    <p className="overline text-[var(--slate)] rise rise-1">
                        Medpax, LLC · Est. United States
                    </p>
                    <h1
                        data-testid="hero-heading"
                        className="font-display mt-6 text-[clamp(2.25rem,9vw,5.25rem)] leading-[1.04] text-[var(--ink)] rise rise-2"
                    >
                        Building thoughtful
                        <br />
                        <span className="italic text-[var(--ink-line)]">
                            apps for modern life.
                        </span>
                    </h1>
                    <p
                        data-testid="hero-subheading"
                        className="mt-8 max-w-xl text-lg text-[var(--slate)] leading-relaxed rise rise-3"
                    >
                        Medpax is an independent software studio based in
                        Texas, USA — the company behind{" "}
                        <span className="text-[var(--ink)]">ExpatsSphere</span>{" "}
                        and{" "}
                        <span className="text-[var(--ink)]">Vitala</span>. We
                        design calm, considerate products that help people feel
                        at home wherever life takes them.
                    </p>
                    <div className="mt-10 flex flex-wrap gap-4 rise rise-4">
                        <a
                            href="#products"
                            data-testid="hero-cta-products"
                            className="inline-flex items-center gap-2 h-12 px-6 bg-[var(--ink)] text-white text-sm tracking-wide hover:bg-[var(--ink-line)] transition-colors"
                        >
                            Our products
                            <ArrowUpRight className="h-4 w-4" />
                        </a>
                        <a
                            href="#contact"
                            data-testid="hero-cta-contact"
                            className="inline-flex items-center gap-2 h-12 px-6 bg-[var(--ink)] text-white text-sm tracking-wide hover:bg-[var(--ink-line)] transition-colors"
                        >
                            Contact us
                            <ArrowUpRight className="h-4 w-4" />
                        </a>
                    </div>
                </div>

                {/* Editorial studio plaque — replaces the former blue texture panel */}
                <div className="col-span-12 lg:col-span-5 min-w-0 rise rise-3">
                    <div
                        data-testid="hero-plaque"
                        className="relative aspect-[4/5] w-full bg-[#F8F6F1] border border-[var(--line)] flex flex-col"
                    >
                        {/* Corner ticks */}
                        <Tick className="absolute top-4 left-4" />
                        <Tick className="absolute top-4 right-4 rotate-90" />
                        <Tick className="absolute bottom-4 left-4 -rotate-90" />
                        <Tick className="absolute bottom-4 right-4 rotate-180" />

                        {/* Center mark + wordmark */}
                        <div className="flex-1 flex flex-col items-center justify-center gap-6 px-10">
                            <MarkCircleSeal size={96} color="#0A192F" />
                            <div className="w-16 h-px bg-[var(--ink)]/30" />
                            <p className="font-display text-5xl md:text-6xl text-[var(--ink)] leading-none tracking-tight">
                                Medpax
                            </p>
                            <p className="font-display italic text-[var(--ink-line)] text-lg">
                                thoughtful by design
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 md:px-12 mt-20">
                <div className="rule" />
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-8 text-sm">
                    {[
                        ["Founded", "United States"],
                        ["Entity", "Medpax, LLC"],
                        ["Focus", "Consumer apps"],
                        ["Domains", "2 published"],
                    ].map(([k, v]) => (
                        <div key={k} data-testid={`hero-stat-${k.toLowerCase()}`}>
                            <p className="overline text-[var(--slate)]">{k}</p>
                            <p className="font-display text-xl text-[var(--ink)] mt-2">
                                {v}
                            </p>
                        </div>
                    ))}
                </div>
                <div className="rule" />
            </div>
        </section>
    );
};

const Tick = ({ className = "" }) => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        className={className}
        aria-hidden="true"
    >
        <path
            d="M0 0 L8 0 M0 0 L0 8"
            stroke="#0A192F"
            strokeWidth="1.2"
        />
    </svg>
);
